import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IUser } from '../../model/types';
import { IRegisterConfirmDTO } from '../model/types';
import { registerApi } from './client';

export const useRegisterWithoutOTP = (
  options?: UseMutationOptions<IUser, AxiosError, IRegisterConfirmDTO>
) => {
  return useMutation<IUser, AxiosError, IRegisterConfirmDTO>({
    mutationFn: async (payload) => {
      const res = await registerApi.registerWithoutOTP(payload);
      return res.data;
    },
    ...options,
  });
};
